module.exports = __webpack_public_path__ + "img/home.06092776.svg";